
  import {defineComponent, h, nextTick, reactive} from 'vue'
  import {useRoute, useRouter} from "vue-router";
  import {useStore} from '@/store';
  import { Toast } from 'scvant';
  import {GetCheckStandards} from '@/service'
  interface State {
    imgList: object;
  }
  export default defineComponent({
      name: "detectStandard",
      setup() {
          let state: State = reactive({
            imgList: {}
          })
          document.title= "检测标准";
          const {query} = useRoute();
          const {styleCode} = query;
        Toast.loading({
            duration: 0,
            forbidClick: true,
            message: '加载中...',
        });
        GetCheckStandards({styleCode}).then((res: any) => {
            state.imgList = res;
            Toast.clear();
        }).catch((err) => {
            console.error(err)
        })
          return {
              state,
          }
      },
  });
  